<div *ngIf="!data?.disableClose" class="closing-x-wrap">
    <mat-icon class="close-icon" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<div class="content">
    <h1 mat-dialog-title>Change Dealership</h1>
   
    <form class="management-search-form search-form" [formGroup]="dealersForm">
        <mat-form-field appearance="fill"  class="search-field">
            <mat-label>Search by dealer name or code</mat-label>
            <mat-placeholder>Search by dealer name or code</mat-placeholder>
            <input #searchInput class="form-control" type="text" matInput formControlName="search" />
            <button matSuffix mat-icon-button aria-label="Search" type="submit">
                <mat-icon *ngIf="!isLoading">search</mat-icon>
                <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
            </button>
        </mat-form-field>
    </form>
    <p style="text-align: center;" *ngIf="allDealershipsForUser.length === 0" >No Dealerships Found</p>
    <div class="dealer-table-wrapper" *ngIf="!isLoading && allDealershipsForUser.length > 0" [style]="getTableHeight()">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 dealer-table">
            <!-- Position Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by dealer name" class="dealer-name-col">Dealer</th>
                <td mat-cell *matCellDef="let element" class="dealer-name-col">
                    {{ element.name ? element.name : 'N/A' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="dealerCode">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by dealer code" class="dealer-code-col">Dealer Code</th>
                <td mat-cell *matCellDef="let element" class="dealer-code-col">
                    {{ element.dealerCodeDisplay }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="changeDealershp(row.dealerId)"></tr>
        </table>
    </div>
    <div class="record-counter" *ngIf="showRecordCount()">
        <p>
            <strong>{{ totalRecords }} records</strong>
        </p>
    </div>
</div>
<three-dot-loader [isTopAligned]="true" *ngIf="isLoading || loadingDealerChange "></three-dot-loader>
